import { useEffect, useState } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { FcAddImage } from 'react-icons/fc';
import {BsPlay} from 'react-icons/bs';
import firebase from 'firebase';
import { userPhone, userName, firestore } from './Firebase';

const Joinroom = (props) => {
	const [passWord, setPassWord] = useState('');
	const roomId = localStorage.getItem('room-id');
	const audioSrcRef = firestore.doc(`playHouse/${roomId}`);

	function addMe() {
		if (passWord === props.roomDet.passWord) {
			audioSrcRef.update({
				members: firebase.firestore.FieldValue.arrayUnion(userPhone),
			});
			alert('Nice Your a member now');
		} else {
			alert('Incorrect Password');
		}
	}

	return (
		<div className="flex-col join-room">
			<input placeholder="Password" onChange={(e) => setPassWord(e.target.value)} />
			<button onClick={(e) => addMe(e)}>Join</button>
		</div>
	);
};

const Playroom = () => {
	const [audioSrc, setAudiosSrc] = useState('');
	const [roomDet, setRoomDet] = useState('');
	const ref = firestore.collection(`users/${userPhone}/audios`).orderBy('createdAt');
	const roomId = localStorage.getItem('room-id');
	const audioSrcRef = firestore.doc(`playHouse/${roomId}`);
	const [audios] = useCollectionData(ref, { idField: 'id' });
	const [myAudios, setMyAudios] = useState([]);
	const [isMember, setIsMember] = useState(true);
	const [playerInfo, setPlayerInfo] = useState({
		nameOfAudioPlaying: 'Audio',
		personPlaying: 'Believe',
	});

	useEffect(
		(e) => {
			if (audios) {
				setMyAudios(audios);
			}
		},
		[audios]
	);

	useEffect((e) => {
		audioSrcRef.onSnapshot((snap) => {
			setAudiosSrc(snap.data().audio);
			setPlayerInfo({
				nameOfAudioPlaying: snap.data().nameOfAudioPlaying,
				personPlaying: snap.data().personPlaying,
			});
		});

		audioSrcRef.get().then((snap) => {
			const roomInfo = {
				passWord: snap.data().passWord,
				members: snap.data().members,
				owner: snap.data().owner,
				audio: snap.data().audio,
				name:snap.data().name,
				personPlaying: snap.data().personPlaying,
				nameOfAudioPlaying: snap.data().nameOfAudioPlaying,
			};

			//checks if user is a member
			setRoomDet(roomInfo);
			if (snap.data().members.indexOf(userPhone) === -1) {
				setIsMember(false);
			}
		});
	}, []);

	function playMySong(e, src, audioName) {
		audioSrcRef.update({
			audio: src,
			personPlaying: localStorage.getItem('user-name'),
			nameOfAudioPlaying: audioName,
		});
	}

	return (
		<div className="page play-room">
			<div className="top flex-col">
			<h4>{roomDet.name}</h4>
				<audio src={audioSrc} autoPlay loop controls />

				<div className="info flex-col-left">
					<span>{playerInfo.nameOfAudioPlaying} </span>
					<span>{playerInfo.personPlaying}</span>
				</div>
			</div>

			<ul className="flex-col-start center">
				{myAudios.map((a) => {
					return (
						<li className="flex-start my-room-audio" key={a.src}>
						<span className="flex" onClick={(e) => playMySong(e, a.src, a.audioName)}><BsPlay/></span>
							<p >{a.audioName}</p>
						</li>
					);
				})}
			</ul>

			{!isMember && <Joinroom roomDet={roomDet} />}
		</div>
	);
};

export default Playroom;
